<!-- Contact / Recipient section loader -->
<div *ngIf="section === 'contactListing-Loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contactListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-75 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- userslisting --->

<div *ngIf="section === 'userslisting-Loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader organizationListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-4 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-2"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- playbook template --->

<div *ngIf="section === 'playbook-temaplte-loading'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader organizationListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>

            <div class="ph-row">
                <div class="ph-col-8 big"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 big"></div>
            </div>
        </div>
    </div>
</div>




<div *ngIf="section === 'playbook-template-loading'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader organizationListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>

            <div class="ph-row">
                <div class="ph-col-8 big"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 big"></div>
            </div>
        </div>
    </div>
</div>




<!-- export modal --->
<div *ngIf="section === 'export-Loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader organizationListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row">
                <div class="ph-col-4 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-2"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 empty"></div>
            </div>
        </div>
    </div>
</div>


<!-- Documents section Loader -->
<div *ngIf="section === 'documentslisting-Loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader organizationListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row">
                <div class="ph-col-4 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
                <div class="ph-col-2 mx-75 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-2"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 empty"></div>
                <div class="ph-col-2 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- Organization section loader -->
<div *ngIf="section === 'organizationListing-Loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader organizationListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-75 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- Document section loader -->
<div *ngIf="section === 'documentLoader'">
    <div class="ph-item contactlisting-placeholer-loader document-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-75 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- Document type section loader -->
<div *ngIf="section === 'document_type'">
    <div class="ph-item contactlisting-placeholer-loader document-type-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-75 big"></div>
            </div>
        </div>
    </div>
</div>

<!-- Document type section loader -->
<div *ngIf="section === 'advanced_filters'">
    <div class="ph-item contactlisting-placeholer-loader document-type-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row">
                <div class="ph-col-12 big"></div>
            </div>
        </div>
    </div>
</div>

<!-- Document field section loader -->
<div *ngIf="section === 'document_fields'">
    <div class="ph-item contactlisting-placeholer-loader document-field-setting-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row m-0">
                <div class="ph-col-4 big mt-0"></div>
                <div class="ph-col-4 big mt-0"></div>
                <div class="ph-col-4 big mt-0"></div>
            </div>
        </div>
    </div>
</div>

<!-- index data modal loader -->
<div *ngIf="section === 'user-stats-item'">
    <div class="ph-item contactlisting-placeholer-loader document-field-setting-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row m-0">
                <div class="ph-col-6 big mt-0"></div>
                <div class="ph-col-6 big mt-0"></div>
            </div>
        </div>
    </div>
</div>


<!-- index data modal loader -->
<div *ngIf="section === 'index_data_model_skeleton'">
    <div class="ph-item contactlisting-placeholer-loader document-field-setting-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row m-0">
                <div class="ph-col-6 big mt-0"></div>
                <div class="ph-col-6 big mt-0"></div>
            </div>
        </div>
    </div>
</div>

<!-- Contract Control section loader -->
<div *ngIf="section === 'contract_control'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contract_controlLoader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-75 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- Contract Control detail view section loader -->
<div *ngIf="section === 'contract_control_detail_view'">
    <div class="ph-item contactlisting-placeholer-loader contact-control-detailview-loader">
        <div class="ph-col-12 pb-2">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-12 big"></div>
                <div class="ph-col-8"></div>
            </div>
        </div>
        <div class="ph-col-12 pb-2" *ngFor="let loader of loop">
            <div class="ph-row detail-view">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-1 big"></div>
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- Contract Control right sidebar loader -->
<div *ngIf="section === 'contract_control_sidebar'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contract_controlrightSidebarLoader">
        <div class="ph-col-12">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big mt-1"></div>
                <div class="ph-col-4 big mx-75 mt-1"></div>
            </div>
        </div>

        <div class="ph-col-12">
            <div class="ph-row m-0 w-100 ms-2">
                <div class="ph-col-4 big"></div>
                <div class="ph-col-2 mx-50 big"></div>
                <div class="ph-col-4 big"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="skeleton-list-box">
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Legal hub right sidebar loader -->
<div *ngIf="section === 'legal_hub_sidebar'">
       <div class="ph-item contactlisting-placeholer-loader tableListing-loader documentRightSidebarLoader">
        <div class="ph-col-12">
            <div class="ph-row">
                <div class="ph-col-6 big mt-1"></div>
            </div>
        </div>

        <div class="ph-col-12">
            <div class="ph-row m-0 w-100 ms-2">
                <div class="ph-col-4 big"></div>
                <div class="ph-col-2 mx-50 big"></div>
                <div class="ph-col-4 big"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
    </div>
</div>

<!-- Edit template section loader -->
<div *ngIf="section === 'edit_template'">
    <div class="ph-item contactlisting-placeholer-loader document-field-loader">
        <div class="ph-col-12">
            <div class="ph-row detail-view">
                <div class="ph-col-6 big"></div>

                <div class="content-laoder-area">
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Edit template rightmenu section loader -->
<div *ngIf="section === 'edit_template_rightmenu'">
    <div class="ph-item contactlisting-placeholer-loader document-field-loader">
        <div class="ph-col-12">
            <div class="ph-row detail-view">
                <div class="ph-col-6 big"></div>

                <div class="content-laoder-area">
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- dashboad widgets section loader -->
<div *ngIf="section === 'dashboard_wrapper_loader'">
    <div class="ph-item contactlisting-placeholer-loader dashboard-wrapper-loader-wrapper document-field-loader">
        <div class="ph-col-12">
            <div class="ph-row detail-view">
                <div class="content-laoder-area">
                    <div class="ph-col-6 big content-laoder"></div>
                    <span class="d-flex justify-content-between align-items-center columngap">
                        <div class="ph-col-6 big content-laoder w-49"></div>
                        <div class="ph-col-6 big content-laoder w-49"></div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- general-popover-settings section loader -->
<div *ngIf="section === 'general-popover-settings'">
    <div class="ph-item contactlisting-placeholer-loader document-field-loader">
        <div class="ph-col-12">
            <div class="ph-row detail-view">
                <div class="ph-col-6 big"></div>

                <div class="content-laoder-area">
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                    <div class="ph-col-6 big content-laoder"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- recipient_fields section loader -->
<div *ngIf="section === 'recipient_fields'">
    <div class="ph-item contactlisting-placeholer-loader recipient-field-loader">
        <div class="ph-col-12 recipient-loader-left">
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-35"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-15"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-15"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-15"></div>
            </div>
        </div>
        <div class="ph-col-12 recipient-loader-middle">
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-35"></div>
            </div>

            <div class="recipient-loader-middle-cont">
                <div class="ph-col-12 recipient-loader-innerMiddle pt-1">
                    <!-- <div class="skeleton-w-50-box">
                        <div class="ph-row w-50">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-50">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div> -->

                    <div class="skeleton-list-box">
                        <div class="ph-row w-25">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-75">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-25">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-75">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-25">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-75">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-25">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-75">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-25">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-75">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-25">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-75">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-25">
                            <div class="ph-col-6 big"></div>
                        </div>
                        <div class="ph-row w-75">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>
                </div>

                <div class="ph-col-12 recipient-loader-right pt-1">
                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                    </div>

                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                    </div>

                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                    </div>

                    <div class="ph-row">
                        <div class="ph-col-6 big"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="ph-col-12 recipient-loader-right">
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
            </div>
        </div> -->
    </div>
</div>

<!-- roles section loader -->
<div *ngIf="section === 'rolesSection'">
    <div class="ph-item contactlisting-placeholer-loader recipient-field-loader group-section-loader">
        <div class="ph-col-12 recipient-loader-middle">
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-35"></div>
            </div>

            <div class="recipient-loader-middle-cont">
               
                <div class="ph-col-12 recipient-loader-innerMiddle pt-1">
                        
                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Template section loader -->
<div *ngIf="section === 'templatesMainSection'">
    <div class="ph-item contactlisting-placeholer-loader template-section-loader tableListing-loader">
        <div class="ph-col-12 pb-2" *ngFor="let loader of loop">
            <div class="ph-row detail-view m-0">
                <div class="ph-col-4 mx-1 big"></div>
                <div class="ph-picture m-0"></div>
                <div class="ph-col-4 mx-1 big"></div>
                <div class="ph-switch m-0"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-2 mt-0"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- Select template section loader -->
<div class="select-template-skeleton" *ngIf="section === 'select-template'">
    <div class="ph-item contactlisting-placeholer-loader document-field-loader">
        <div class="ph-col-12">
            <div class="ph-row detail-view">
                <div class="content-laoder-area">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Select template section loader -->
<div class="select-template-skeleton" *ngIf="section === 'content-library'">
    <div class="ph-item contactlisting-placeholer-loader document-field-loader">
        <div class="ph-col-12">
            <div class="ph-row detail-view">
                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>
                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>

                <div class="content-laoder-area content-library">
                    <div class="ph-col-6 big content-laoder content-laoder-left"></div>
                    <div class="ph-col-6 big content-laoder content-laoder-right"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- groups-section Mainsidebar loader -->
<div *ngIf="section === 'groups-section-LoaderMainsidebar'">
    <div class="ph-item contactlisting-placeholer-loader recipient-field-loader groupMainsidebar-section-loader">
        <div class="ph-col-12 recipient-loader-left">
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-35"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-15"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-15"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-15"></div>
            </div>
        </div>
    </div>
</div>

<!-- groups-section loader -->
<div *ngIf="section === 'groups-section-Loader'">
    <div class="ph-item contactlisting-placeholer-loader recipient-field-loader group-section-loader">
        <div class="ph-col-12 recipient-loader-middle">
            <div class="ph-row">
                <div class="ph-col-6 big loaderBar-height-35"></div>
            </div>

            <div class="recipient-loader-middle-cont">
                <div class="ph-col-12 recipient-loader-innerMiddle pt-1">
                    
                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>

                    <div class="skeleton-list-box">
                        <div class="ph-row w-100">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- edit groups right sidebar loader -->
<div *ngIf="section === 'edit_groups_sidebar'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader editGroupRightSidebarLoader">
        <div class="ph-col-12">
            <div class="ph-row">
                <div class="ph-picture me-50"></div>
                <div class="ph-col-6 big mt-1"></div>
                <div class="ph-col-4 big mx-75 mt-1"></div>
            </div>
        </div>

        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row m-0 w-90 ms-2">
                <div class="ph-col-12 big"></div>
                <div class="ph-col-12 big"></div>
                <div class="ph-col-12 big"></div>
            </div>
        </div>
    </div>
</div>

<!-- Audit Trial loader -->
<div *ngIf="section === 'audit_trial_loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader audiTrialLoader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row m-0 w-90 ms-2">
                <div class="ph-col-12 big"></div>
                <div class="ph-col-12 big"></div>
                <div class="ph-col-12 big"></div>
            </div>
        </div>
    </div>
</div>

<!-- Contract Control section loader -->
<div *ngIf="section === 'contract_control-pie-chart'">
    <div class="ph-item contract_control-pie-chart-img">
        <div class="ph-col-12">
            <div class="d-flex justify-content-center">
                <div class="ph-picture"></div>
            </div>
        </div>
    </div>
</div>

<!-- Contract Control column chart loader -->
<div *ngIf="section === 'contract_control_column_chart'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contract_controlColumnChartLoader">
        <div class="ph-col-12 py-2 mb-0">
            <div class="skeleton-list-box">
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contract Control column chart loader -->
<div *ngIf="section === 'contract_control_Upcoming_column_chart'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contract_controlColumnChartLoader">
        <div class="ph-col-12 py-2 mb-0">
            <div class="skeleton-list-box">
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="section === 'contract_control_events_chart'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contract_controlColumnChartLoader">
        <div class="ph-col-12 py-2 mb-0">
            <div class="skeleton-list-box">
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="section === 'contract_control_events_SideBar_chart'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contract_controlColumnChartLoader">
        <div class="ph-col-12 py-2 mb-0">
            <div class="skeleton-list-box">
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="section === 'dashboard_Contract_Event_Loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contract_controlColumnChartLoader">
        <div class="ph-col-12 py-2 mb-0">
            <div class="skeleton-list-box">
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar100"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar150"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
                <div class="ph-row CC_graphBarWidht">
                    <div class="ph-col-6 big CC_graphBar"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contact / Recipient right side bar section loader -->
<div *ngIf="section === 'contact-right-sidebar-documentTab-Loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contactListing-Loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-12 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>

<!-- Document right sidebar loader -->
<div *ngIf="section === 'document_Right_Sidebar'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader documentRightSidebarLoader">
        <div class="ph-col-12">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big mt-1"></div>
                <div class="ph-col-4 big mx-75 mt-1"></div>
            </div>
        </div>

        <div class="ph-col-12">
            <div class="ph-row m-0 w-100 ms-2">
                <div class="ph-col-4 big"></div>
                <div class="ph-col-2 mx-50 big"></div>
                <div class="ph-col-4 big"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
            <div class="ph-row m-0 w-100">
                <div class="ph-col-4"></div>
                <div class="ph-col-4 ms-2"></div>
            </div>
        </div>
        <div class="ph-col-12 py-2 mb-0">
            <div class="skeleton-list-box">
                <div class="ph-row document_thumbnailWidht">
                    <div class="ph-col-6 big document_thumbnail"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Signing Sidebar Activity Tabs loader -->
<div *ngIf="section === 'activity-tab-signing-sidebar-loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contactListing-Loader activity-tab-signing">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row">
                <div class="ph-col-12 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>
<!-- / Signing Sidebar Activity Tabs loader -->

<!-- Signing Sidebar Parties Tabs loader -->
<div *ngIf="section === 'parties-tab-signing-sidebar-loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contactListing-Loader parties-tab-signing">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-12 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
                <div class="ph-col-8 empty"></div>
            </div>
        </div>
    </div>
</div>
<!-- / Signing Sidebar Parties Tabs loader -->

<!-- Signing Sidebar Document Tabs loader -->
<div *ngIf="section === 'document-tab-signing-sidebar-loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contactListing-Loader document-tab-signing">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-12 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
            </div>
        </div>
    </div>
</div>
<!-- / Signing Sidebar Document Tabs loader -->

<!-- Signing Sidebar More Tabs loader -->
<div *ngIf="section === 'more-tab-signing-sidebar-loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader contactListing-Loader more-tab-signing">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-12 big"></div>
            </div>
            <div class="ph-row">
                <div class="ph-col-4"></div>
            </div>
        </div>
    </div>
</div>
<!-- / Signing Sidebar More Tabs loader -->

<!-- Signing Sidebar More Tabs loader -->
<div *ngIf="section === 'match-columns-loader'">
    <div class="ph-item contactlisting-placeholer-loader document-field-setting-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row m-0">
                <div class="ph-col-12 big mt-0"></div>
            </div>
        </div>
    </div>
</div>
<!-- / Signing Sidebar More Tabs loader -->

<!-- Categories section loader -->
<div *ngIf="section === 'categories-section-loader'">
    <div class="ph-item contactlisting-placeholer-loader categories-section-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-75 big"></div>
                <div class="ph-picture"></div>
            </div>
        </div>
    </div>
</div>

<!-- Document type section loader -->
<div *ngIf="section === 'category-loader'">
    <div class="ph-item contactlisting-placeholer-loader document-type-loader tableListing-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-picture"></div>
            <div class="ph-row">
                <div class="ph-col-6 big"></div>
                <div class="ph-col-4 mx-75 big"></div>
            </div>
        </div>
    </div>
</div>

<!-- branding section loader -->
<div *ngIf="section === 'branding_section_loader'">
    <div class="ph-item contactlisting-placeholer-loader tableListing-loader branding_section_loader_wrapper">
        <div class="ph-col-12 py-2 mb-0 border-bottom">
            <div class="skeleton-list-box justify-content-center">
                <div class="ph-row branding_logo_Loader">
                    <div class="ph-col-6 big branding_thumbnailWidht"></div>
                    <div class="ph-col-6 big branding_thumbnailWidht"></div>
                </div>
            </div>
        </div>
        <div class="ph-col-12 mt-2 border-bottom pb-1">
            <div class="ph-row">
                <div class="ph-col-6 big mt-1"></div>
                <div class="ph-col-4 big mx-75 mt-1"></div>
            </div>
        </div>
        <div class="ph-col-12 mt-2 border-bottom pb-1">
            <div class="ph-row">
                <div class="ph-col-6 big mt-1"></div>
                <div class="ph-col-4 big mx-75 mt-1"></div>
            </div>
        </div>
        <div class="ph-col-12 mt-2 border-bottom pb-1">
            <div class="ph-row">
                <div class="ph-col-6 big mt-1"></div>
                <div class="ph-col-4 big mx-75 mt-1"></div>
            </div>
        </div>
        <div class="ph-col-12 mt-2 border-bottom pb-1">
            <div class="ph-row">
                <div class="ph-col-6 big mt-1"></div>
                <div class="ph-col-4 big mx-75 mt-1"></div>
            </div>
        </div>
    </div>
</div>

<!-- Contract Control Overview section loader -->
<div *ngIf="section === 'cc_overview'">
    <div class="ph-item contactlisting-placeholer-loader document-field-loader">
        <div class="ph-col-12" *ngFor="let loader of loop">
            <div class="ph-row detail-view">
                <div class="ph-col-12 big mb-2"></div>
                <div class="ph-col-6 big"></div>
            </div>
        </div>
    </div>
</div>